import {useContext, useEffect} from 'react';
import {useParams} from 'react-router-dom';

import {request, URLs} from '../../api';
import {ContestViewData} from '../../api/responses/ContestViewResponseTypes';
import AppContext from '../../context/AppContext';

function ContestModuleChangeFallback() {
  const context = useContext(AppContext);
  const {id, groupContest: groupContestId, page} = useParams();

  useEffect(() => {
    if (!groupContestId || isNaN(Number(groupContestId))) {
      request<{}, {}, ContestViewData>(URLs.getGroupContest(Number(groupContestId)), {
        method: 'GET',
        successCallback() {
          context.dispatchError({
            errorMessage: 'There was an error. Please try again later',
            redirectURL: '/profile',
          });
        },
        errorCallback(err: any) {
          if (err) {
            if (err.response && err.response.data && err.response.data.error) {
              if (err.response.data.error == 'MOVE_TO_OTHER_MODULE') {
                const redirectURL = `/contest/${groupContestId}/${page}`;

                const moveToModuleEntry = err.response.data.moveToModuleEntry;

                context.changeModuleContext(moveToModuleEntry, redirectURL);
              } else {
                context.dispatchError({errorMessage: err.response.data.error, redirectURL: '/problems'});
              }
            } else {
              context.dispatchError({
                errorMessage: 'There was an error. Please try again later',
                redirectURL: '/problems',
              });
            }
          }
        },
      });
    }
  }, [context.user, id, groupContestId]);
  return <></>;
}

export default ContestModuleChangeFallback;
